import script from "./ProviderInformationFormPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderInformationFormPreview.vue?vue&type=script&setup=true&lang=js"

import "./ProviderInformationFormPreview.vue?vue&type=style&index=0&id=32b35a6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b35a6a"]])

export default __exports__